import React, { Component } from "react";

const COLUMN_KEYS = [
  ["Unity", "C#", "Python", "Github"],
  ["HTML 5", "CSS 3", "JavaScript", "React"],
  ["Wordpress", "MySql", "Canva"],
];

class Skills extends Component {
  componentDidMount() {
    this.attachObserver();
  }

  componentDidUpdate() {
    this.attachObserver();
  }

  attachObserver() {
    if (this._obsAttached) return;
    const cols = document.querySelectorAll(".sk-col");
    if (!cols.length) return;
    this._obsAttached = true;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            e.target.querySelectorAll(".sk-fill").forEach((bar) => {
              setTimeout(() => { bar.style.width = bar.dataset.p + "%"; }, 100);
            });
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -30px 0px" }
    );
    cols.forEach((el) => obs.observe(el));
  }

  render() {
    let sectionName = "Skills";
    let skillMap = {};
    let ui = {};

    if (this.props.sharedSkills && this.props.resumeBasicInfo) {
      sectionName = this.props.resumeBasicInfo.section_name.skills;
      ui = this.props.resumeBasicInfo.ui || {};
      this.props.sharedSkills.icons.forEach((s) => {
        skillMap[s.name] = s.level;
      });
    }

    const colTitles = ui.skills_cols || ["Game Development", "Frontend", "Other"];

    return (
      <section id="skills">
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <p className="sec-eye rv">{ui.skills_eyebrow || "Loadout"}</p>
          <h2 className="sec-h rv" style={{ transitionDelay: ".05s" }}>
            <span>{sectionName}</span> &amp; {ui.skills_tools || "TOOLS"}
          </h2>
          <div className="skills-wrap">
            {COLUMN_KEYS.map((keys, ci) => (
              <div
                className="sk-col rv"
                key={ci}
                style={{ transitionDelay: `${ci * 0.1}s` }}
              >
                <div className="sk-col-title">{colTitles[ci]}</div>
                {keys.map((name) => {
                  const level = skillMap[name] || "0";
                  return (
                    <div className="sk-row" key={name}>
                      <div className="sk-info">
                        <span className="sk-name">{name}</span>
                        <span className="sk-pct">{level}%</span>
                      </div>
                      <div className="sk-bar">
                        <div
                          className="sk-fill"
                          data-p={level}
                          style={{ width: 0 }}
                        ></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default Skills;
